function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#BCCDD8;}\n");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "logo");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_1_"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M101.5,104.8h-78L9.8,138H0.6L58.1,0.4h9.4L125.1,138h-10L101.5,104.8z M98.3,96.8l-35.6-87l-36,87H98.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M144.8,17.7V138h-9.2V0.4h11.2l52.9,102.3L251.9,0.4h10.7V138h-9.2V18l-51.1,99h-5.9L144.8,17.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M283.5,0.4h9.2V138h-9.2V0.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M322.7,78.8V138h-9.2V0.4h26c33.7,0,45,18.8,45,36.7c0,23.8-18.2,41.3-47.6,41.3h-2.2l58.4,59.6h-12.4 L322.7,78.8z M322.7,8.3v62.1h15.9c21.4,0,36.5-14.8,36.5-33.4c-0.2-12.9-9-28.8-35.6-28.8L322.7,8.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.4,161h9.2v60.3h82.2V161h9.2v137.6h-9.2v-69.3H19.6v69.3h-9.2V161z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M277.4,229.6c0,40.6-33.7,73.4-75,73.4c-41.7,0-75.2-32.8-75.2-73.4c0-40.4,33.6-73,75.2-73 C243.6,156.6,277.4,189.2,277.4,229.6z M136.5,229.4c0,34.5,29.9,65.3,65.8,65.3c35.8,0,65.6-30.4,65.6-65.3 c0-33.7-29.9-64.5-65.6-64.5C166.4,164.9,136.5,195.7,136.5,229.4L136.5,229.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M350.9,175.6c-7.6-5-17.7-9-28.6-9c-21,0-26.4,13.8-26.4,21c0,10.9,6.5,20.1,28.2,31.5 c27.3,14.4,38.2,26.7,38.2,43.1c0,25.6-20.1,38.5-43.9,38.5c-11.6,0-27.1-3.5-35.2-9.8l0.5-10.9c12,8.5,21.4,12.4,35.4,12.4 c23.6,0,33.8-15.7,33.8-29.5c0-12.7-8.5-23.4-32.8-36.1c-24.7-12.9-33.6-24.3-33.6-38.5c0-15.1,11.6-30.1,35.2-30.1 c8.9,0,20.8,1.8,29.7,6.8L350.9,175.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M444.4,175.6c-7.6-5-17.7-9-28.6-9c-21,0-26.4,13.8-26.4,21c0,10.9,6.5,20.1,28.2,31.5 c27.3,14.4,38.2,26.7,38.2,43.1c0,25.6-20.1,38.5-43.9,38.5c-11.6,0-27.1-3.5-35.2-9.8l0.5-10.9c12,8.5,21.4,12.4,35.4,12.4 c23.6,0,33.7-15.7,33.7-29.5c0-12.7-8.5-23.4-32.8-36.1c-24.7-12.9-33.6-24.3-33.6-38.5c0-15.1,11.6-30.1,35.2-30.1 c8.9,0,20.8,1.8,29.7,6.8L444.4,175.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M473,161h63.8v7.9h-54.6V220h51.1v8h-51.1v62.7h56v7.9H473V161z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M556.3,161h9.2v137.6h-9.2V161z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M595.6,174.5v124.1h-9.2V161h11.4l85.6,120.6V161h9.2v137.6h-9.2L595.6,174.5z"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 693 303.4",
    style: {
      enableBackground: "new 0 0 693 303.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.fc9e491b.svg";
export { ForwardRef as ReactComponent };